import React from 'react'
import ReportData from '../Credit/DataComponent/ReportData.jsx'
import Header from '../../component/Header.jsx'
import { FormattedMessage } from 'react-intl'
import { Box, useMediaQuery } from '@mui/material'
import '../../css/global.css'

export const Report = ({ boxSize, defaultBox }) => {
    const isLargeScreen = useMediaQuery("(min-width: 1200px)")

    return (
        <Box sx={boxSize}>
            <Header title={<FormattedMessage id='reportNav' />} />

            <Box
                mt="20px"
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap="20px"
                sx={{
                    "& > div": { gridColumn: isLargeScreen ? undefined : "span 12" }
                }}
            >
                <Box sx={defaultBox}>
                    <ReportData/>
                </Box>
            </Box>
        </Box>
    )
}
